import { useEffect } from 'react';
import { subscribeConsentLevelChange } from '@stepstone/user-consent-events';
import { updateConsent } from '../redux/core/consent/consentSlice.js';
import { useAppDispatch } from '../redux/hooks.js';
import { modalActions } from '../redux/wrappers/Modal/modalSlice.js';
export const useConsentLevelSubscriber = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        const unsubscribe = subscribeConsentLevelChange((e) => {
            dispatch(updateConsent(e.detail.isFunctional));
        });
        return () => unsubscribe();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
const consentLevelChangeCallback = (dispatch) => () => {
    dispatch(modalActions.setGDPRModalActive(false));
};
export const useGDPRModalActive = () => {
    const dispatch = useAppDispatch();
    useEffect(() => {
        let unsubscribe;
        if (typeof window !== 'undefined') {
            const observer = new MutationObserver(() => {
                const target = document.querySelector('#GDPRConsentManagerContainer > *');
                if (target) {
                    dispatch(modalActions.setGDPRModalActive(true));
                    unsubscribe = subscribeConsentLevelChange(consentLevelChangeCallback(dispatch));
                    observer.disconnect();
                }
            });
            observer.observe(document.body, {
                childList: true,
                subtree: true,
            });
        }
        return () => {
            if (typeof unsubscribe === 'function') {
                unsubscribe();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
//# sourceMappingURL=useConsentLevel.js.map